module.exports = __webpack_public_path__ + "img/Logo FIL Promotion_Bleu.cc3f68b6.svg";